import React, { FC } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import Buckets from './buckets'
import BucketPage from './bucket-page'
import ObjectUsers from './users'
import ObjectUserPage from './user-page'
import { PageContainer } from './styles'

type ObjectStorageRouteProps = {
  section: 'storage' | 'users'
  bucketListPath?: string
  userListPath?: string
}

const StaffObjectStorage: FC<ObjectStorageRouteProps> = ({ section, bucketListPath, userListPath }) => {
  if (section === 'storage' && bucketListPath) {
    return (
      <Routes>
        <Route
          index
          element={(
            <PageContainer>
              <Buckets bucketListPath={bucketListPath} />
            </PageContainer>
          )}
        />
        <Route
          path=":bucketId/*"
          element={<BucketPage bucketListPath={bucketListPath} userListPath={userListPath || ''} />}
        />
        <Route path="*" element={<Navigate replace to={bucketListPath} />} />
      </Routes>
    )
  }

  if (section === 'users' && userListPath) {
    return (
      <Routes>
        <Route
          index
          element={(
            <PageContainer>
              <ObjectUsers userListPath={userListPath} />
            </PageContainer>
          )}
        />
        <Route path=":objectUserId/*" element={<ObjectUserPage userListPath={userListPath} />} />
        <Route path="*" element={<Navigate replace to={userListPath} />} />
      </Routes>
    )
  }

  return null
}

export default StaffObjectStorage
